module.exports = __webpack_public_path__ + "img/J11.d13fb68b.webp";